import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import classNames from 'classnames';
import 'react-dual-listbox/lib/react-dual-listbox.css';

import { RootState } from '../../reducers';
import './Start.scss';
import * as _actionsSujet from '../../actions/sujet';
import * as _actionsBasket from '../../actions/basket';
import * as _actionsFilters from '../../actions/filters';
import { getParameterByName } from '../../utils/toSearchParams';
import BreadCrumbs from '../../components/BreadCrumbs';
import bsStyles from '../../styles/bs.module.scss';
import { useNavigate } from 'react-router';
import { Button, EButtonType } from '@repo/apg-ui';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import AgencyCampaignModal from '../../components/Modal/AgencyCampaign';
import { PartiallyIntegratedUserDataEC } from '../../reducers/app';

interface Props {
  history: any;
  location: any;
  actions: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  actionsSujet: typeof _actionsSujet;
  actionsBasket: typeof _actionsBasket;
  actionsFilters: typeof _actionsFilters;
  customersForAgency: any;
  intl: any;
}

const AgencyStart = (props: Props) => {
  const navigate = useNavigate();

  useEffect(() => {
    openCreateCampaignModal();
  }, []);

  const openCreateCampaignModal = () => {
    navigate({ search: '?modalContent=createNewCampaign' });
  };

  const renderModalContent = (modalContent) => {
    if (modalContent === 'createNewCampaign') {
      return (
        <AgencyCampaignModal
          isEditModal={false}
          onAgencyCampaignChange={(name, customer) => {
            navigate({
              pathname: '/journey2/1',
              search: '',
            });
          }}
          onClose={() => {
            navigate({ search: '' });
          }}
          onSuccess={() => {}}
        />
      );
    } else {
      return null;
    }
  };

  const renderAgencyStart = () => {
    const modalContent = getParameterByName('modalContent', props.location.search);

    return (
      <div className='pageContainer agency-start'>
        {modalContent && (
          <Modal
            isOpen={Boolean(modalContent)}
            onRequestClose={() => {
              navigate({ search: '' });
            }}
            shouldCloseOnOverlayClick={true}
            className={'large-modal overlow-unset'}
            closeTimeoutMS={0}
            overlayClassName={'overlay'}
          >
            <div
              className={classNames('background-light-grey modal overflow-unset', bsStyles.bootstrap, {
                'extra-medium-modal': modalContent === 'createNewCampaign',
              })}
            >
              {modalContent && renderModalContent(modalContent)}
            </div>
          </Modal>
        )}

        <div className='main'>
          <div className='bg-white start-card'>
            <div className='start-title'>
              <FormattedMessage id='ec.campaign.agencyPanel' defaultMessage='Agency panel' />
            </div>
            <div className='start-hint'>
              <FormattedMessage
                id='ec.agency.createNewCampaignInfo'
                defaultMessage='Beginnen Sie, indem Sie unten auf die Schaltfläche Neue Kampagne erstellen klicken.'
              />
            </div>
            <div className='start-action'>
              <Button onClick={openCreateCampaignModal} buttonType={EButtonType.PillMedium}>
                <Plus />
                <FormattedMessage id='ec.agency.createNewCampaign' defaultMessage='Neue Kampagne erfassen' />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <BreadCrumbs />
      <div className='container-fluid agency-journey p-0'>{renderAgencyStart()}</div>
    </>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AgencyStart);
